import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    modal_container: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.common.white,
        borderRadius: '4px',
        padding: '16px',
        border: `1px solid ${theme.palette.grey[200]}`,
        maxHeight: '80vh',
        overflowY: 'auto',
        width: '100%'
    },
    input: {
        marginTop: '16px'
    },
    margin_right_5: {
        marginRight: "5px"
    },
    full_width: {
        width: '100%'
    },
    show_money_price_table: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: '10px',
        width: '100%'
    },
    show_money_price_info_container: {
        position: 'relative',
        marginTop: '4px',
        display: 'grid',
        gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr));",
        gridColumnGap: '8px',
        gridRowGap: '8px',
        backgroundColor: theme.palette.common.white,
        borderRadius: 4,
        padding: 8,
        border: `1px solid ${theme.palette.grey["400"]}`,
        borderLeft: `8px solid ${theme.palette.success.light}`,
        width: '98%',
        "&:hover": {
            backgroundColor: `${theme.palette.grey[200]}`,
            cursor: 'pointer',
            border: `1px solid ${theme.palette.secondary.light}`,
            borderLeft: `8px solid ${theme.palette.secondary.light}`,
        }
    },
    show_money_price_info_container_small: {
        position: 'relative',
        marginTop: '4px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        placeItems: 'stretch',
        rowGap: 16,
        columnGap: 16,
        backgroundColor: theme.palette.common.white,
        borderRadius: 4,
        padding: 8,
        border: `1px solid ${theme.palette.grey["400"]}`,
        borderLeft: `8px solid ${theme.palette.success.light}`,
        width: '100%',
    },
    values_container: {
        display: 'flex',
        gap: '30px'
    },
    package_sale_prices_table: {
        display: 'flex',
        flexDirection: 'column',
    },
    category_container: {
        marginBottom: '32px',
        padding: '16px',
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: '8px',
        backgroundColor: theme.palette.grey[50],
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
    },
    category_header: {
        borderBottom: `2px solid ${theme.palette.primary.main}`,
        paddingBottom: '8px',
        marginBottom: '16px',
        display: 'flex',
        alignItems: 'center',
    },
    category_name: {
        fontSize: '20px',
        fontWeight: 700,
        color: theme.palette.primary.main,
    },
    elements_container: {
        
    },
    delivery_type_header: {
        display: 'flex',
        gap: '5px',
        alignItems: 'center',
        fontSize: '19px',
        fontWeight: 600,
        marginTop: '30px'
    },
    empty_delivery_type: {
        padding: '10px !important'
    },
}));

export {useStyles}